export type DynamicCardProps = {
  carouselCode: string;
  type: DynamicCardType;
  title: string;
  description: string;
  image: string;
  tagLabel?: string;
  ctaIcon?: string;
  ctaLabel: string;
  ctaStyle: DynamicCardCTAStyle;
  TMModalContent?: string;
  enableTMModal: boolean;
  action: () => void;
};

export enum DynamicCardCTAStyle {
  fill = "fill",
  unfill = "unfill"
}

export enum DynamicCardType {
  tile = "tile",
  full = "full",
}
